// Lightweight API client. Always sends credentials (cookies).
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

async function request(path, { method = "GET", body, headers = {} } = {}) {
    const opts = {
        method,
        credentials: "include",
        headers: { "Content-Type": "application/json", ...headers },
    };
    if (body !== undefined) opts.body = JSON.stringify(body);
    const r = await fetch(`${API}${path}`, opts);
    if (!r.ok) {
        const text = await r.text().catch(() => "");
        // Don't pollute console for the expected 401 auth probe
        const err = new Error(`HTTP ${r.status}: ${text}`);
        err.status = r.status;
        err.silent = r.status === 401;
        throw err;
    }
    if (r.status === 204) return null;
    return r.json();
}

export const api = {
    get: (p) => request(p),
    post: (p, body) => request(p, { method: "POST", body }),
    put: (p, body) => request(p, { method: "PUT", body }),
    patch: (p, body) => request(p, { method: "PATCH", body }),
    del: (p) => request(p, { method: "DELETE" }),
    API_BASE: API,
};
